import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { style } from "./styles";
import { Grid, Paper, Button } from "@material-ui/core";
import InputFormat from "../../../partials/inputForm";
import Snackbar from "../../snackbar";

export class ProductMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data || { name: {} },
    };
  }
  async componentDidMount() {
    // this.props.onRef(this);
  }
  componentWillReceiveProps = (nextProps) => {
    let { data } = this.state;
    if (nextProps.data && nextProps.data.categoryId !== data.categoryId)
      this.setState({
        data: nextProps.data,
      });
  };
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let { data = { name: {} } } = this.state;
    if (name === "name") {
      data.name.vi = value;
    } else if (name === "englishName") {
      data.name.en = value;
    } else data[name] = value;
    this.setState({
      data,
    });
  };
  handleAction = (type, data) => {
    let { t } = this.props;
    if (data.name && data.name.en) {
      if (type === "update") this.props.handleUpdate(data);
      else if (type === "create") this.props.handleCreate(data);
    } else
      this.mSnackbar.handleClick(
        t("plugin_category_english_name_is_required"),
        "warning"
      );
  };
  render() {
    const { t, classes, handleCreate, handleUpdate } = this.props;
    let { data } = this.state;
    return (
      <Paper className={classes.container}>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFormat
              required
              label={t("list_plugin_category_english_name")}
              name="englishName"
              value={data.name && data.name.en}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFormat
              label={t("list_plugin_category_name")}
              name="name"
              value={data.name && data.name.vi}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InputFormat
              label={t("list_plugin_category_key")}
              name="key"
              value={data.key}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {handleUpdate && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.handleAction("update", data)}
                className={classes.button}
              >
                {t("plugin_category_updateBtn")}
              </Button>
            )}
            {handleCreate && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.handleAction("create", data)}
                className={classes.button}
              >
                {t("plugin_category_createBtn")}
              </Button>
            )}
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: 0 })(ProductMenu)));
